import { Component, OnInit, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { CommonService } from 'src/app/Global-Services/common.service';
import { Event, Router, ActivatedRoute, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { GlobalVariable } from 'src/app/Variable/global-variable';
import { AppTokenHandler, HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { WindowRefService } from 'src/app/Global-Services/window-ref.service';
import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http'; //added by vedha bethi

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: false,
})
export class HeaderComponent implements OnInit {

  _win: any;
  Initials: string;
  LoaderStatus = true;
  CurrUserGPN = '';
  IsSLHR = false;
  IsCounsellor = false;
  IsPartner = false;
  FullName: any;
  IsAdmin = false;
  Roles = [];
  IsManager = false;
  IsAdmin1 = false;
  IsBUOUSpoc = false;
  href: any;
  IsFinanceTeam = false; //added by vedha bethi
  constructor(private gservice: CommonService, public _navigateRoute: Router, private httpStatus: HTTPStatus,
    private cdRef: ChangeDetectorRef, public globalvariable: GlobalVariable, private _window: WindowRefService, private tokenHandler: AppTokenHandler, private _Location: Location) {
    this._win = _window.nativeWindow;
    this.httpStatus.getHttpStatus().subscribe((status: boolean) => {
      this.LoaderStatus = status;
    });
    _navigateRoute.events.subscribe((RouterEvent: Event) => {
      if (RouterEvent instanceof NavigationStart) {
        this.LoaderStatus = true;
      }
      if (RouterEvent instanceof NavigationEnd || RouterEvent instanceof NavigationCancel || RouterEvent instanceof NavigationError) {
        this.LoaderStatus = false;
      }
    });

  }

  ngOnInit() {
    // this.href = this._Location.path();
    // this.gservice.userAuthentication(this.href);
    this.globalvariable.User = this.gservice.getUserDetails('zero');
    this.CurrUserGPN = this.globalvariable.User.UserGPN;
    this.Roles = this.globalvariable.User._ApplicationRole.split(',');

    this.IsAdmin = this.Roles.indexOf('Admin') > -1 ? true : false;
    this.IsCounsellor = this.Roles.indexOf('IsCounsellor') > -1 ? true : false;
    this.IsPartner = this.Roles.indexOf('IsPartner') > -1 ? true : false;
    this.IsSLHR = this.Roles.indexOf('IsSLHR') > -1 ? true : false;
    this.IsAdmin1 = this.Roles.indexOf('Admin1') > -1 ? true : false; //added by samikchha kumar on 25/05/2023
    this.IsManager = this.Roles.indexOf('IsManager') > -1 ? true : false; //added by samikchha kumar on 28/05/2023
    this.IsBUOUSpoc = this.Roles.indexOf('BUOUSpoc') > -1 ? true : false;

    this.FullName = this.globalvariable.User.FullName;
    this.CheckUserIsFinanceTeam(this.globalvariable.User.UserGPN);//added by vedha bethi on 15-jun-2021 for CR_2103_0066
  }

  logout() {
    this._navigateRoute.navigate(['/logout']);
  }

  AddToFavourite() {
    const bookmarkURL = window.location.href;
    const bookmarkTitle = document.title;
    if (this._win.sidebar && this._win.sidebar.addPanel) {
      this._win.sidebar.addPanel(bookmarkTitle, bookmarkURL, '');
    } else if (this._win.external && ('AddFavorite' in this._win.external)) {
      // IE Favorites
      this._win.external.AddFavorite(bookmarkURL, bookmarkTitle);
    } else {
      // Other browsers (mainly WebKit & Blink - Safari, Chrome, Opera 15+)
      alert('Press ' + (/Mac/i.test(navigator.platform) ? 'Cmd' : 'Ctrl') + '+D to bookmark this page.');
    }
  }
  // added by vedha bethi on 09-jun-2021 for CR_2103_0066
  CheckUserIsFinanceTeam(Value: any) {
    this.gservice.PostService({ userGPN: Value }, 'FTEDetails/CheckUserIsFinanceTeam').subscribe((data: any) => {
      if (data != null && data.length > 0) {
        this.IsFinanceTeam = true;
      }
      else {
        this.IsFinanceTeam = false;

      }
    },
      (err: HttpErrorResponse) => {
        this.gservice.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gservice.RedirectToErrorPage(2);
      });
  }
  // end by vedha bethi on 09-jun-2021 for CR_2103_0066


}
